import React, { Component, Fragment } from 'react';
import Dropzone from 'react-dropzone';
import Select from 'react-select';
import Toggle from 'react-toggle';
import CurrencyInput from 'react-currency-input';
import { FaCloudUploadAlt, FaTimes } from 'react-icons/fa';

import {
  Content,
  DropContainer,
  DropContent,
  Footer,
  ToggleContainer,
  ImageContainer,
} from './styles';
import {
  Row,
  Label,
  SelectLabel,
  CurrencyLabel,
  Textarea,
  Input,
} from '../../../../../assets/styles';

class Information extends Component {
  state = {
    file: null,
    image: null,
    name: '',
    category: '',
    shortDescription: '',
    price: 0,
    priceMasked: '',
    visible: true,
    nameError: false,
    nameFocus: false,
    categoryError: false,
    shortDescriptionError: false,
    shortDescriptionFocus: false,
    priceError: false,
    priceFocus: false,
  }

  componentWillMount = () => {
    const { currentCategory, currentMaterial } = this.props;

    if (currentCategory) {
      this.handleSelectChange({ value: currentCategory.value, label: currentCategory.label });
    }

    if (currentMaterial) {
      this.setState({
        image: { url: currentMaterial.imageUrl },
        name: currentMaterial.name,
        category: { value: currentCategory.value, label: currentCategory.label },
        shortDescription: currentMaterial.shortDescription,
        price: currentMaterial.price,
        priceMasked: new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(currentMaterial.price),
        visible: currentMaterial.visible,
      });
    }
  }

  handleSubmit = async () => {
    await this.validateInputs();

    const {
      file,
      image,
      name,
      category,
      shortDescription,
      price,
      visible,
      imageError,
      nameError,
      categoryError,
      shortDescriptionError,
      priceError,
    } = this.state;

    if (!imageError && !nameError && !categoryError && !shortDescriptionError && !priceError) {
      return {
        file,
        imageUrl: image.url,
        name,
        categoryId: category.value,
        shortDescription,
        price,
        visible,
      };
    }

    return false;
  }

  validateInputs = () => {
    const {
      image,
      name,
      category,
      shortDescription,
      price,
    } = this.state;

    this.setState({
      nameError: false,
      categoryError: false,
      shortDescriptionError: false,
      priceError: false,
    });

    if (!image) this.setState({ imageError: true });
    if (name.length === 0) this.setState({ nameError: true });
    if (category.length === 0) this.setState({ categoryError: true });
    if (shortDescription.length === 0) this.setState({ shortDescriptionError: true });
    if (price === 0 || price > 999999.99) this.setState({ priceError: true });
  }

  handleUpload = (file) => {
    this.setState({
      file,
      image: { preview: URL.createObjectURL(file) },
      imageError: false,
    });
  }

  deleteImage = () => {
    this.setState({ image: null, file: null });
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSelectChange = (value) => {
    this.setState({ category: value });
  }

  handlePriceValueChange = (event, maskedValue, floatValue) => {
    this.setState({
      priceMasked: maskedValue,
      price: floatValue,
    });

    this.props.handleOriginalPrice(floatValue);
  }

  handleToggleButton = () => {
    this.setState(state => ({ visible: !state.visible }));
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  render() {
    const {
      image,
      name,
      category,
      shortDescription,
      priceMasked,
      visible,
      imageError,
      nameError,
      nameFocus,
      categoryError,
      shortDescriptionError,
      shortDescriptionFocus,
      priceError,
      priceFocus,
    } = this.state;

    return (
      <Fragment>
        {this.props.active && (
          <Fragment>
            <Content>
              <div className="left">
                <DropContainer>
                  {!image && (
                    <Dropzone
                      accept={['image/png', 'image/jpeg']}
                      multiple={false}
                      maxSize={2000000}
                      onDropAccepted={file => this.handleUpload(file[0])}
                    >
                      {({
                        getRootProps, getInputProps, isDragActive, isDragReject,
                      }) => (
                        <DropContent
                          {...getRootProps()}
                          isDragActive={isDragActive}
                          isDragReject={isDragReject || (imageError || this.props.imageError)}
                        >
                          <FaCloudUploadAlt className="fa fa-cloud-upload-alt" />
                          <h3>Enviar imagem</h3>
                          <div className="info">
                            <p>Tamanho máx. 2 MB</p>
                            <div className="format">
                              <span>JPG</span>
                              <span>PNG</span>
                            </div>
                          </div>
                          <input {...getInputProps()} />
                        </DropContent>
                      )}
                    </Dropzone>
                  )}
                  {image && (
                    <ImageContainer isDragReject={this.props.imageError}>
                      <div className="img" style={{ backgroundImage: `url(${image.url || image.preview})` }} />
                      <button type="button" className="delete" onClick={this.deleteImage}>
                        <FaTimes className="fas fa-times" />
                        <span>Remover</span>
                      </button>
                    </ImageContainer>
                  )}
                </DropContainer>
              </div>
              <div className="right">
                <Row>
                  <div className="row-2">
                    <Label>
                      <p className="fieldName">Nome</p>
                      <Input
                        type="text"
                        name="name"
                        value={name}
                        error={nameError}
                        onFocusInput={nameFocus}
                        onChange={this.handleInputChange}
                        onFocus={() => this.onFocus('nameFocus')}
                        onBlur={() => this.onBlur('nameFocus')}
                      />
                    </Label>
                    <Label>
                      <p className="fieldName">Categoria</p>
                      <SelectLabel error={categoryError}>
                        <Select
                          className="input"
                          classNamePrefix="input"
                          placeholder="Selecione a categoria"
                          defaultValue={category}
                          options={this.props.categories}
                          onChange={value => this.handleSelectChange(value)}
                          isClearable={false}
                          isSearchable={false}
                        />
                      </SelectLabel>
                    </Label>
                  </div>
                  <Label>
                    <p className="fieldName">Descrição</p>
                    <Textarea
                      name="shortDescription"
                      maxLength="300"
                      value={shortDescription}
                      error={shortDescriptionError}
                      onFocusInput={shortDescriptionFocus}
                      onChange={this.handleInputChange}
                      onFocus={() => this.onFocus('shortDescriptionFocus')}
                      onBlur={() => this.onBlur('shortDescriptionFocus')}
                    />
                  </Label>
                  <div className="row-2">
                    <Label>
                      <p className="fieldName">Preço</p>
                      <CurrencyLabel error={priceError} onFocusInput={priceFocus}>
                        <CurrencyInput
                          size="10"
                          prefix="R$ "
                          decimalSeparator=","
                          thousandSeparator="."
                          className="input"
                          value={priceMasked}
                          onChangeEvent={this.handlePriceValueChange}
                          onFocus={() => this.onFocus('priceFocus')}
                          onBlur={() => this.onBlur('priceFocus')}
                        />
                      </CurrencyLabel>
                    </Label>
                    <Label />
                  </div>
                </Row>
              </div>
            </Content>
            <Footer>
              <ToggleContainer>
                <Toggle
                  defaultChecked={!visible}
                  icons={false}
                  onChange={this.handleToggleButton}
                />
                <span>Desativar material</span>
              </ToggleContainer>
              <p>
                {'Se o botão estiver habilitado este material não aparecerá na lista de materiais da sua loja no aplicativo Reforma Fácil.'}
              </p>
            </Footer>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default Information;
